import { useVerificationFlow } from '../../VerificationFlow/VerificationFlowContext'
import { VerificationStep, PartnerType, FlowType } from '../../VerificationFlow/types'
import { TopicKey } from '../../../../constants/customerMessages'

/**
 * A safe wrapper around useVerificationFlow that provides fallbacks when the context isn't available.
 * This prevents errors when components are rendered outside of a VerificationFlowProvider.
 */
export function useSafeVerificationFlow() {
  try {
    // Try to use the verification flow context
    return useVerificationFlow();
  } catch (error) {
    // If the context isn't available, return fallback values
    return {
      state: { 
        currentStep: 'idle' as VerificationStep,
        isVerified: false,
        partnerData: null,
        partnerType: 'LoanOfficer' as PartnerType
      },
      dispatch: () => {}, // No-op dispatch function
      startVerification: (message: string, topicKey: TopicKey, defaultTopicKey: TopicKey, partnerType?: PartnerType, flowType?: FlowType) => {}, // No-op startVerification function
      options: {
        enableVerificationFlow: false,
        initialPartnerType: 'LoanOfficer' as PartnerType,
        initialVerificationState: false,
        triggerOnMessageSent: false
      }
    };
  }
}
